/* components/SiteHeader.ts
Global Site Header

Example
<site-header>
    Site header content here
</site-header>
*/

import { Component, Prop, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { EastSlider } from '../EastSlider/EastSlider';

@Component
export class GroupFilter extends ThemeComponent {

    @Ref() filters!: HTMLButtonElement[];

    private targetParent: HTMLElement|null = null;
    private targetGroup: HTMLElement|null = null;
    private targetGroupElements: NodeListOf<HTMLElement>|null = null;
    private selectedFilter: string|null = '';

    init() {

        this.targetParent = this.closest('.group-filter__parent');
        this.targetGroup = this.targetParent?.querySelector('.group-filter__target') || null;

        if (this.filters) {
            for (const filter of this.filters) {

                this.$listen(filter, 'click', () => {

                    for (const filter of this.filters) {
                        filter.classList.remove('group-filter__button--active');
                    }

                    filter.classList.add('group-filter__button--active');
                    this.selectedFilter = filter.getAttribute('data-filter');
                    this.targetGroup?.classList.add('fadeOut');

                });
            }
        }

        if (this.targetGroup) {
            this.$listen(this.targetGroup, 'transitionend', (event) => {
                if (this.targetGroup?.classList.contains('fadeOut')) {
                    if (this.targetParent && this.targetGroup) {

                        this.targetGroupElements = this.targetGroup.querySelectorAll('[data-group]');

                        for (const element of this.targetGroupElements) {

                            const elementFilter = element.getAttribute('data-group');

                            if (elementFilter != this.selectedFilter) {
                                element.classList.add('hidden');
                            } else {
                                element.classList.remove('hidden');
                            }

                        }
                        this.targetGroup?.classList.remove('fadeOut');

                    }
                }
            });
        }

    }

}
